import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';

interface CompanyTerritory {
  id: number;
  displayLabel: string;
}

// Represents the shape expected by react-select component (value/label format)
// Transformed from CompanyTerritory for use in the dropdown and component state
interface TerritoryOption {
  value: number;
  label: string;
}

export interface TerritoriesProps {
  allCompanyTerritories: CompanyTerritory[];
  companyTerritories: CompanyTerritory[];
}

function initialTerritoriesSelected(
  territoryOptions: TerritoryOption[],
  companyTerritories: CompanyTerritory[]
): TerritoryOption[] {
  const selectedTerritoryIds = companyTerritories.map(t => t.id);
  return territoryOptions.filter(o => selectedTerritoryIds.includes(o.value));
}

export default function Territories({
  allCompanyTerritories,
  companyTerritories
}: TerritoriesProps) {
  const territoryOptions = allCompanyTerritories.map(t => ({ value: t.id, label: t.displayLabel }));
  const [selectedTerritories, setSelectedTerritories] = useState<TerritoryOption[]>(
    () => initialTerritoriesSelected(territoryOptions, companyTerritories)
  );

  return (
    <>
      <h3 className="top-buffer-lg">Territories</h3>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={territoryOptions}
            value={selectedTerritories}
            onChange={(value) => setSelectedTerritories(value as TerritoryOption[])}
          />
        </Col>
      </Row>

      {selectedTerritories.map((territory) => (
        <input
          key={territory.value}
          name="company[territory_ids][]"
          type="hidden"
          value={territory.value}
        />
      ))}
    </>
  );
}